var _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "192px",
    height: "260px",
    viewBox: "0 0 192 260",
    enableBackground: "new 0 0 192 260",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "189.818,136.221 183.113,126.437 180.903,106.347 185.05,90.802 155.375,93.409 144.647,80.397 134.987,77.988  114.947,79.602 114.476,79.503 107.175,72.724 108.143,58.445 98.235,43.247 92.648,45.333 99.65,25.244 114.401,5.527 109.782,2  89.395,11.76 69.28,14.764 57.658,30.558 55.771,41.286 20.707,75.778 29.424,86.854 30.64,123.507 30.144,124.003 22.52,149.333  11.693,149.804 2.182,164.903 32.925,185.414 49.737,185.265 88.426,211.017 99.501,229.517 118.772,225.072 145.79,234.31  134.789,251.271 147.354,258 155.946,210.818 152.569,199.122 145.492,193.038 149.192,163.835 176.135,163.537 189.346,157.602  181.275,144.887 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.286a25e63b2e1d139c98b420666f6203.svg";
export { ForwardRef as ReactComponent };